export class TokenRequest {
  username = '';
  password = '';
  grant_type = '';
  migrate = false;
}
